import React from 'react';
import { useAuth } from '../contexts/AuthContext';
export default function BillingPage() {
  const { pharmacy } = useAuth();
  return (
    <div style={{ padding: '28px 32px', fontFamily: 'Inter, system-ui, sans-serif', maxWidth: 520 }}>
      <h1 style={{ margin: '0 0 4px', fontSize: 24, fontWeight: 800, color: '#0F172A' }}>Billing</h1>
      <p style={{ margin: '0 0 24px', fontSize: 13, color: '#94A3B8' }}>Subscription details</p>
      <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #E2E8F0', padding: 28 }}>
        <div style={{ fontSize: 13, display: 'grid', gap: 12 }}>
          <div style={{ display: 'flex' }}>
            <span style={{ color: '#94A3B8', width: 160, flexShrink: 0 }}>Subscription Tier</span>
            <span style={{ fontWeight: 600, color: '#0F172A', textTransform: 'capitalize' }}>
              {pharmacy?.subscriptionTier || 'Standard'}
            </span>
          </div>
          <div style={{ display: 'flex' }}>
            <span style={{ color: '#94A3B8', width: 160, flexShrink: 0 }}>Status</span>
            <span style={{ fontWeight: 600, color: '#16A34A' }}>Active</span>
          </div>
          <div style={{ display: 'flex' }}>
            <span style={{ color: '#94A3B8', width: 160, flexShrink: 0 }}>Pharmacy</span>
            <span style={{ fontWeight: 500, color: '#0F172A' }}>{pharmacy?.name || '—'}</span>
          </div>
        </div>
        <div style={{ marginTop: 24, padding: '14px 16px', background: '#F8FAFC',
          borderRadius: 8, fontSize: 12, color: '#64748B' }}>
          To make changes to your plan, contact <strong>admin@blisterflow.ca</strong>
        </div>
      </div>
    </div>
  );
}
